export default {
  en: {
    global: {
      required: 'The {field} field is required.',
      email: 'E-mail is not valid',
      numeric: '{field} has to be numeric',
      between: 'Number {field} has to be between {min} and {max}',
      maxLength: '{field} length has to be at most {max} characters in lenght',
      minLength: '{field} length has to be at least {min} characters in lenght',
      maxValue: '{field} can not be over {max}',
      minValue: '{field} has to be at least {min}'
    },
    custom: {},
    attributes: {
      'register.budgetUserId': 'Budget number',
      'register.companyNumber': 'Company number',
      'register.executionAccount': 'Execution account',
      'register.taxIdNumber': 'Tax Id number',
      'register.name': 'Company name',
      'register.companyName': 'Company / legal entity name',
      'register.legalEntityName': 'Legal entity name',
      'register.address': 'Address',
      'register.treasuryBranch': 'Treasury branch',
      'register.email': 'Company e-mail',
      'register.phoneNumber': 'Company phone',
      'register.adminName': 'Name and last name',
      'register.adminPersonalIdentityNumber': 'Personal identity number',
      'register.adminIdentityNumber': 'Identity number',
      'register.adminEmail': 'Admin rmail',
      'register.adminPhoneNumber': 'Admin phone',
      'user.login': 'User login',
      'user.name': 'User name',
      'user.email': 'User email',
      'user.password': 'Password',
      'user.newPassword': 'New password',
      'password.oldPassword': 'Old password',
      'password.newPassword': 'New password',
      'password.confirmNewPassword': 'Confirm new password',
      'notification.text': 'Notification text',
      'notification.validUntilDate': 'Valid until',
      'notification.priority': 'Priority',
      'issue.name': 'Name and surname',
      'issue.personalIdentityNumber': 'Personal identity number',
      'issue.description': 'Description',
      'issue.email': 'Email',
      'issue.identificationNumber': 'Identification number'
    }
  },
  sr: {
    global: {
      required: '{field} је обавезно поље.',
      email: 'Имејл адреса није валидна.',
      numeric: '{field} може да садржи само бројеве',
      between: '{field} мора бити између {min} и {max}.',
      maxLength: '{field} може имати највише {max} карактера',
      minLength: '{field} мора имати најмање {min} карактера',
      maxValue: '{field} не може бити већи од {max}',
      minValue: '{field} не може бити мањи од {min}'
    },
    custom: {
      form: {
        name: {
          required: 'Upisi ime',
          minLength: 'Ime mora imati najmanje 5 karaktera'
        }
      },
      role: {
        Claims: {
          required: 'Минимум једно овлашћење мора бити изабрано.'
        }
      },
      issue: {
        name: {
          required: 'Име је обавезно поље',
          minLength: 'Име мора садржати најмање 4 карактера',
          validName: 'Име може садржати само слова, размак и цртицу'
        },
        mobilePhoneNumber: {
          required: 'Број мобилног телефона је обавезно поље',
          minLength: 'Број мобилног телефона мора садржати најмање 10 карактера',
          maxLength: 'Број мобилног телефона мора садржати највише 11 карактера',
          validMobilePhone: 'Број мобилног телефона мора имати позивни број српског оператера'
        }
      }
    },
    attributes: {
      'registerAccount.uniqueIdentificationNumber': 'ЈМБГ',
      'registerAccount.identificationNumber': 'Број личне карте',
      'registerAccount.accountNumberFirstParty': 'Број банке',
      'registerAccount.accountNumberMiddleParty': 'Број рачуна',
      'registerAccount.accountNumberLastParty': 'Контролни број',
      'registerAccount.firstName': 'Име',
      'registerAccount.lastName': 'Презиме',
      'registerAccount.dateOfBirth': 'Датум рођења',
      'registerAccount.bank': 'Банка',
      'registerAccount.formattedDateOfBirth': 'Датум рођења',
      'registerAccount.description': 'Опис проблема',
      'registerAccount.formattedActivationId': 'Идентификатор пријаве',
      'registerPayment.identificationNumber': 'Број личне карте',
      'registerPayment.amount': 'Износ плаћања',
      'updateUser.rejectionComments': 'Разлог искључивања приватног лица',
      'userActivation.identificationNumber': 'Број личне карте',
      'userActivation.activationComments': 'Идентификатор интервенције',
      'retrieveUser.uniqueIdentificationNumber': 'ЈМБГ',
      'retrieveUser.identificationNumber': 'Број личне карте',
      'user.login': 'Кориснички налог',
      'user.name': 'Име и презиме',
      'user.email': 'Имејл корисника',
      'user.password': 'Шифра',
      'user.newPassword': 'Нова шифра',
      'password.oldPassword': 'Стара шифра',
      'password.newPassword': 'Нова шифра',
      'password.confirmNewPassword': 'Потврди нову шифру',
      'notification.text': 'Текст нотификације',
      'notification.validUntilDate': 'Датум застаревања',
      'notification.priority': 'Приоритет',
      'role.Name': 'Назив улоге',
      'role.Description': 'Опис',
      'filter.userType': 'Тип корисника',
      'issue.name': 'Име и презиме',
      'issue.description': 'Опис',
      'issue.email': 'Адреса електронске поште',
      'issue.identificationNumber': 'Број личне карте',
      'issue.uniqueIdentificationNumber': 'ЈМБГ',
      'issue.problemType': 'Тип проблема',
      'issue.mobilePhoneNumber': 'Број мобилног телефона',
      'issue.userType': 'Тип корисника'
    }
  }
}
